<script lang="ts" setup>
import { setOptions, importLibrary } from '@googlemaps/js-api-loader'

const props = defineProps<{
  lat: number
  lng: number
}>()

const style = [
  {
    featureType: 'administrative',
    elementType: 'geometry',
    stylers: [
      {
        color: '#ffeb3b',
      },
      {
        visibility: 'simplified',
      },
    ],
  },
  {
    featureType: 'administrative',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#18246f',
      },
    ],
  },
  {
    featureType: 'administrative.land_parcel',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'administrative.neighborhood',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'landscape',
    elementType: 'geometry',
    stylers: [
      {
        color: '#f1faff',
      },
      {
        visibility: 'simplified',
      },
    ],
  },
  {
    featureType: 'landscape',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'poi',
    elementType: 'geometry',
    stylers: [
      {
        color: '#d8eaf3',
      },
      {
        visibility: 'simplified',
      },
    ],
  },
  {
    featureType: 'poi',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'geometry',
    stylers: [
      {
        color: '#b1c8d2',
      },
      {
        visibility: 'simplified',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'labels.icon',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'transit',
    elementType: 'geometry',
    stylers: [
      {
        color: '#c8dce5',
      },
      {
        visibility: 'simplified',
      },
    ],
  },
  {
    featureType: 'transit',
    elementType: 'labels.icon',
    stylers: [
      {
        color: '#18246f',
      },
    ],
  },
  {
    featureType: 'transit',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#18246f',
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [
      {
        color: '#c6ecff',
      },
      {
        visibility: 'simplified',
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
]

const config = useRuntimeConfig()

const position = {
  lat: props.lat,
  lng: props.lng,
}

const gmap = ref<HTMLDivElement | null>(null)

onMounted(async () => {
  setOptions({ key: config.public.googleMapsApiKey })
  try {
    const { Map, StyledMapType } = await importLibrary('maps')
    const { Marker } = await importLibrary('marker')

    const mapStyle = new StyledMapType(style, {
      name: 'Careum',
    })
    const mapOptions = {
      center: position,
      zoom: 13,
      mapTypeControlOptions: {
        mapTypeIds: ['careum'],
      },
    }

    const map = new Map(gmap.value!, mapOptions)
    map.mapTypes.set('careum', mapStyle)
    map.setMapTypeId('careum')

    new Marker({
      icon: '/img/pin.png',
      position,
      map,
      title: '',
    })
  } catch {
    // map area stays empty when the loader fails (same as before)
  }
})
</script>
<template>
  <div ref="gmap" class="map">map</div>
</template>
<style scoped lang="scss">
.map {
  --height: 300px;
  height: var(--height);
}
</style>
